import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OpenHighScreener from "../Screeners/OpenHighScreener";
import OpenLowScreener from "../Screeners/OpenLowScreener";
import SmartMoneyScreener from "../Screeners/SmartMoneyScreener";
import CrossoverMomentum from "../Screeners/CrossoverMomentum";
import HighVolumeScreener from "../Screeners/HighVolumeScreener";
import WeekHighBreakout from "../Screeners/WeekHighBreakout";
import MomentumScreener from "../Screeners/MomentumScreener";
import "./ScreenerPage.css";
import LiveBreakoutTracker from "../Screeners/LiveBreakoutTracker";

// ── All 4 screeners as tabs on one page ────────────────

const SCREENER_TABS = [
  {
    key: "openhigh",
    label: "Open High",
    shortDesc: "Open = High",
    component: OpenHighScreener,
  },
  {
    key: "openlow",
    label: "Open Low",
    shortDesc: "Open = Low",
    component: OpenLowScreener,
  },
  {
    key: "smartmoney",
    label: "Smart Money",
    shortDesc: "Institutional flow",
    component: SmartMoneyScreener,
  },
  {
    key: "crossover",
    label: "Crossover",
    shortDesc: "RSI & MACD signals",
    component: CrossoverMomentum,
  },
  {
    key: "live-breakout",
    label: "Live Crossover Breakout",
    shortDesc: "Bullish P&L live",
    component: LiveBreakoutTracker,
  },
  {
    key: "highvolume",
    label: "High Volume",
    shortDesc: "Unusual volume",
    component: HighVolumeScreener,
  },
  {
    key: "52whigh",
    label: "52W High",
    shortDesc: "Breakout stocks",
    component: WeekHighBreakout,
  },
  {
    key: "momentum-screener",
    label: "Momentum Screener",
    shortDesc: "Momentum Breakout",
    component: MomentumScreener,
  },
];

const ScreenerPage = () => {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState("openhigh");

  const activeTab = SCREENER_TABS.find((t) => t.key === activeKey);
  const ActiveComponent = activeTab.component;

  return (
    <div className="scrn">
      {/* ── Sticky Tab Bar — always visible on top ── */}
      <div className="scrn__tab-bar">
        <button className="scrn__back-btn" onClick={() => navigate(-1)}>
          ←
        </button>

        <div className="scrn__tab-group">
          {SCREENER_TABS.map((tab) => {
            const isActive = tab.key === activeKey;
            return (
              <button
                key={tab.key}
                className={`scrn__tab ${isActive ? "scrn__tab--active" : ""}`}
                data-tab={tab.key}
                onClick={() => setActiveKey(tab.key)}
              >
                <span className="scrn__tab-label">{tab.label}</span>
                <span className="scrn__tab-desc">{tab.shortDesc}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Screener content swaps here ── */}
      <div className="scrn__content">
        <ActiveComponent key={activeKey} />
      </div>
    </div>
  );
};

export default ScreenerPage;
